import { StatusData } from "@fairfleet/geotab";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid-pro";
import { DiagnosticCell } from "@/components/grid/cells/DiagnosticCell";
import { RenderHeader } from "@/components/grid/cells/RenderHeader";
import { useOptionalViewContext } from "@/components/ViewProvider";
import { DeviceStatusOverviewData } from "@/models/DeviceStatusOverviewData";

export function useViewColumns() {
  const ctx = useOptionalViewContext();
  const selectedView = ctx?.selectedView ?? null;

  const columns: GridColDef[] =
    selectedView?.columns?.map(col => {
      const dId = col.diagnosticId;
      return {
        minWidth: 10,
        width: 150,
        field: dId,
        renderHeader: RenderHeader,
        headerName: col.diagnosticName,
        type: "number",
        renderCell: (props: GridRenderCellParams) => <DiagnosticCell props={props} />,
        valueGetter: (_, row: DeviceStatusOverviewData) =>
          ((row.statusData?.statusData ?? []) as unknown as StatusData[])?.find(
            sd => sd.diagnostic.id === dId,
          )?.data ?? 0,
      } as GridColDef;
    }) ?? [];

  return { columns };
}
